<template>
  <mdb-container class="d-flex justify-content-center wrapper2" center fluid>
    <mdb-container class="d-flex justify-content-center fluid firstrow2">
      <img class="bimgbig d-none d-sm-block" src="/static/images/text/nomaginblackfridays.png" />
      <img class="bimg d-sm-none" src="/static/images/text/m_nomaginblackfridays.png" />
    </mdb-container>
  </mdb-container>
</template>

<script>
import { car } from '../api';

export default {
  data() {
    return {
      cars: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    /* eslint-disable1 */
    filterImage(Value) {
      return Value.filter(item => item.hotdealYn === 'y');
    },
    fetchData() {
      car.fetch()
        .then((data) => {
          this.cars = data.data;
        })
        .finally(() => {
        });
    },
  },
};
</script>

<style scoped>
.container-fluid {
  max-width: 100%;
  height: auto;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
.wrapper2 {
  background-color: #212121;
  max-width: 1900px;
  height: auto;
  margin: 0px 0px;
  padding: 0px 0px;
  align-content: center;
  align-items: center;
  align-self: center;
}
.firstrow2 {
  margin: 0px 0px !important;
  height: auto !important;
  max-width: 1348px;
  background-color: white;
  align-content: center;
  align-items: center;
  align-self: center;
  padding: 0 0px;
}
.container {
  padding: 0 0px;
}
.titlerow {
  margin: 0px 0px !important;
  max-height: 100% !important;
  align-items: center;
  margin: 0px 0px !important;
  max-height: 380px !important;
  background-color: white;
  max-width: 1348px;
}
.secondrow2 {
  max-width: 1450px;
  max-height: 3000px;
  background-color: white !important;
  align-items: center;
}
@media (max-width: 500px){
  .wrapper2 {
    background-color: white;
    max-width: 100%;
    height: auto;
    margin: 0px 0px;
    padding: 0px 0px;
  }
}
.bcol {
  align-items: center;
  max-height: 500px;
  max-width: 362px;
}
.col {
  align-items: center;
  max-height: 320px;
  max-width: 362px;
}
@media (max-width: 500px){
  .titlerow {
    margin: 0px 0px !important;
    max-height: 100% !important;
    align-items: center;
    margin: 0px 0px !important;
    max-height: 380px !important;
    background-color: white;
    max-width: 100%;
    height: auto;
  }
}
#moveTack{
  position: absolute;
  left: 50%;
  z-index: -100;
  width: 50px;
  height: 170px;
  margin-top: -1%;
  margin-left: -7%;
  font-size: 0;
  text-indent: -9999px;
  transform-origin: top center;
  animation: swing 3s infinite linear;
  background: url(/static/images/text/crazytagsmall.png) no-repeat;
}
.bimg{
  max-width:  100%;
  height: auto;
  padding: 0 0px;
  margin: 0 0px;
}

.vuejs-countdown {
  margin-top: 0px !important;
}
@media (max-width: 500px){
  .vuejs-countdown {
    max-width: 100%;
    height: auto;
    align-items: center;
    margin: auto auto;
    overflow: hidden;
    margin-left: 25%;
  }
}
.countdown {
  max-width: 100%;
  height: auto;
}
</style>
